
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#593289","d":"M4.068 6h7.864a.5.5 0 01.385.82l-3.933 4.72a.5.5 0 01-.768-.001L3.683 6.82A.5.5 0 014.067 6z"}}),_c('path',{attrs:{"d":"M0 0h16v16H0z"}})])])
          )
        }
      }
    